/* ===========================================================================
  Bossi | Build options on bike pages
  Markup: snippets/bossi-build-options.liquid (questions) and snippets/bossi-build-send.liquid
  (Send this build to Bossi). Data: Content > Metaobjects > Build options in Shopify admin.

  - Shows each question only when its build kit, bike and answer rules allow.
  - Paid upgrades show their price on the choice, and the bike's main price becomes the build
    total while they are picked (Globo's "add add-on to product price").
  - Add to Cart: checks required answers, then adds the bike with its answers as line properties
    and each paid upgrade as a nested line under it (parent_id), and opens the cart page.
  - Send this build: checks the build, attaches it and the price-hold date to the enquiry form.
============================================================================ */
(function () {
  'use strict';

  function money(cents, wrap) {
    var format = (document.body && document.body.getAttribute('data-money-format')) ||
      (wrap && wrap.getAttribute('data-money-format')) || '${{amount}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return String(window.Shopify.formatMoney(cents, format)).replace(/<[^>]*>/g, '');
    }
    return (cents / 100).toFixed(2);
  }

  // For the enquiry email: no invisible spacing characters, and the currency code only once.
  function plain(text, currency) {
    var t = String(text).replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
    return currency && t.indexOf(currency) === -1 ? t + ' ' + currency : t;
  }

  function heldUntil(days) {
    var date = new Date(Date.now() + days * 86400000);
    try {
      return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return date.toDateString();
    }
  }

  // Matches Globo's rule: part of the size and build kit, ignoring capitals.
  function contains(title, list) {
    var t = String(title || '').toLowerCase();
    return (list || []).some(function (k) { return k && t.indexOf(String(k).toLowerCase()) !== -1; });
  }

  function init(root) {
    if (root.getAttribute('data-bossi-ready')) return;
    root.setAttribute('data-bossi-ready', '1');

    var cfg;
    try {
      cfg = JSON.parse(root.querySelector('[data-bossi-build-config]').textContent);
    } catch (e) {
      console.error('Bossi build options: could not read the settings.', e);
      return;
    }

    var wrap = root.closest('[data-product-form]');
    var form = wrap && wrap.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var atc = form.querySelector('.add_to_cart');
    var holdDays = cfg.holdDays || 30;
    var questions = cfg.questions || [];
    var byId = {};

    questions.forEach(function (q) {
      byId[q.id] = q;
      q.box = root.querySelector('[data-q="' + q.id + '"]');
      q.select = q.box.querySelector('select');
      q.error = q.box.querySelector('[data-q-error]');
      q.adds = q.box.querySelector('[data-q-adds]');
    });

    function variant() {
      var input = form.querySelector('[name="id"]');
      var id = input ? Number(input.value) : NaN;
      for (var i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].id === id) return cfg.variants[i];
      return cfg.variants[0];
    }

    function choiceOf(q) {
      var value = q.select.value;
      for (var i = 0; value && i < q.choices.length; i++) if (q.choices[i].id === value) return q.choices[i];
      return null;
    }

    function visibility() {
      var title = (variant() || {}).title || '';
      var memo = {};
      function visible(q, depth) {
        if (memo[q.id] !== undefined) return memo[q.id];
        var ok = (!q.showFor || !q.showFor.length || contains(title, q.showFor)) && !contains(title, q.hideFor) &&
          (q.hideForProducts || []).indexOf(cfg.productId) === -1;
        if (ok && q.whenQ) {
          var source = byId[q.whenQ];
          var answer = source && depth < 10 && visible(source, depth + 1) ? choiceOf(source) : null;
          ok = !!answer && (!q.whenA || !q.whenA.length || q.whenA.indexOf(answer.id) !== -1);
        }
        memo[q.id] = ok;
        return ok;
      }
      questions.forEach(function (q) { visible(q, 0); });
      return memo;
    }

    // Only questions that are showing count: hidden answers are never sent.
    function collect() {
      var shown = visibility();
      var result = { shown: shown, props: {}, upgrades: [], missing: [], lines: [] };
      questions.forEach(function (q) {
        if (!shown[q.id]) return;
        var choice = choiceOf(q);
        if (!choice) {
          if (q.required) result.missing.push(q);
          return;
        }
        var base = q.cartLabel || q.label;
        var key = base;
        for (var n = 2; Object.prototype.hasOwnProperty.call(result.props, key); n++) key = base + ' (' + n + ')';
        result.props[key] = choice.label;
        result.lines.push({ label: key, value: choice.label });
        if (choice.upgrade) result.upgrades.push(choice.upgrade);
      });
      return result;
    }

    function total(result) {
      var v = variant();
      return (v ? v.price : 0) + result.upgrades.reduce(function (sum, u) { return sum + u.price; }, 0);
    }

    // The bike's main price shows the build total while upgrades are picked, as Globo did.
    // Turbo rewrites this element on every size or build kit change, so it is re-applied then.
    var section = root.closest('.shopify-section') || document;
    var priceHost = section.querySelector('.modal_price [data-price-ui]') || section.querySelector('[data-price-ui]');
    var writingPrice = false;
    var priceTouched = false;
    function applyPrice(result) {
      if (!priceHost) return;
      var priceEl = priceHost.querySelector('[data-price]');
      if (!priceEl) return;
      var v = variant();
      // With no upgrades, leave Turbo's own price alone unless it is ours to put back.
      if (!result.upgrades.length && !priceTouched) return;
      priceTouched = result.upgrades.length > 0;
      var cents = result.upgrades.length ? total(result) : (v ? v.price : null);
      if (cents === null) return;
      var text = money(cents, wrap);
      if (priceEl.textContent.trim() === text) return;
      writingPrice = true;
      priceEl.innerHTML = '<span class="money">' + text + '</span>';
      writingPrice = false;
    }
    if (priceHost && window.MutationObserver) {
      new MutationObserver(function () {
        if (!writingPrice) applyPrice(collect());
      }).observe(priceHost, { childList: true, subtree: true, characterData: true });
    }

    var summary = root.querySelector('[data-bossi-summary]');
    var linesEl = root.querySelector('[data-bossi-lines]');
    var totalEl = root.querySelector('[data-bossi-total]');

    function render() {
      var result = collect();
      questions.forEach(function (q) {
        var show = !!result.shown[q.id];
        q.box.hidden = !show;
        var chosen = choiceOf(q);
        if (!show || chosen) {
          q.box.classList.remove('is-invalid');
          q.error.hidden = true;
          q.select.removeAttribute('aria-invalid');
        }
        // Long choice names are cut off in the closed dropdown, so the cost is repeated here.
        if (q.adds) {
          q.adds.hidden = !(show && chosen && chosen.upgrade);
          q.adds.textContent = q.adds.hidden ? '' : 'Adds ' + money(chosen.upgrade.price, wrap);
        }
      });
      linesEl.textContent = '';
      result.upgrades.forEach(function (u) {
        var line = document.createElement('p');
        line.className = 'bossi-build__line';
        var name = document.createElement('span');
        name.textContent = u.title + ': ' + u.variant;
        var price = document.createElement('span');
        price.textContent = '+ ' + money(u.price, wrap);
        line.appendChild(name);
        line.appendChild(price);
        linesEl.appendChild(line);
      });
      totalEl.textContent = money(total(result), wrap);
      summary.hidden = result.upgrades.length === 0;
      applyPrice(result);
      return result;
    }

    function flagMissing(missing) {
      missing.forEach(function (q) {
        q.box.classList.add('is-invalid');
        q.error.hidden = false;
        q.select.setAttribute('aria-invalid', 'true');
      });
      if (!missing.length) return;
      missing[0].box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { missing[0].select.focus({ preventScroll: true }); } catch (e) { missing[0].select.focus(); }
    }

    var cartError = null;
    function showCartError(message) {
      if (!cartError) {
        cartError = document.createElement('p');
        cartError.className = 'bossi-build-cart-error';
        cartError.setAttribute('role', 'alert');
        (atc ? atc.parentNode : form).appendChild(cartError);
      }
      cartError.textContent = message || '';
      cartError.hidden = !message;
    }

    function busy(on) {
      if (!atc) return;
      if (on) {
        atc.setAttribute('disabled', 'disabled');
        atc.classList.add('disabled');
      } else {
        atc.removeAttribute('disabled');
        atc.classList.remove('disabled');
      }
    }

    function addToCart() {
      var result = render();
      if (result.missing.length) {
        flagMissing(result.missing);
        return;
      }
      var v = variant();
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var items = [{ id: v.id, quantity: qty, properties: result.props }];
      result.upgrades.forEach(function (u) { items.push({ id: u.id, quantity: qty, parent_id: v.id }); });

      showCartError('');
      busy(true);
      fetch(cfg.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.text().then(function (body) {
            var data = null;
            try { data = JSON.parse(body); } catch (e) { /* not JSON, e.g. a verification page */ }
            if (!res.ok || !data) {
              throw new Error((data && (data.description || data.message)) ||
                'This build could not be added to the cart. Please try again in a moment.');
            }
            return data;
          });
        })
        .then(function () { window.location.href = cfg.cartUrl; })
        .catch(function (err) {
          busy(false);
          showCartError(err.message);
        });
    }

    // Turbo's own Add to Cart would post the form without the upgrades, so it is taken over here.
    if (atc) {
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart();
      }, true);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart();
    }, true);

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-q-select]')) render();
    });
    wrap.addEventListener('variant-change', function () { setTimeout(render, 0); });
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-q-select]')) setTimeout(render, 50);
    });
    render();

    var sendBox = wrap.querySelector('[data-bossi-send]');
    if (sendBox) initSend(sendBox);

    function initSend(box) {
      var open = box.querySelector('[data-bossi-send-open]');
      var panel = box.querySelector('[data-bossi-send-panel]');
      var sendForm = panel.querySelector('form');
      var model = String(cfg.product || '').split(' - ')[0];
      var fills = [].slice.call(box.querySelectorAll('[data-bossi-fill]'));
      fills.forEach(function (el) { el.setAttribute('data-template', el.textContent); });

      function prepare() {
        var result = render();
        if (result.missing.length) {
          flagMissing(result.missing);
          return null;
        }
        var v = variant();
        var held = heldUntil(holdDays);
        var currency = cfg.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        var build = [cfg.product, 'Size / build kit: ' + v.title + ', ' + money(v.price, wrap)];
        result.lines.forEach(function (l) { build.push(l.label + ': ' + l.value); });
        result.upgrades.forEach(function (u) { build.push('Paid upgrade: ' + u.title + ', ' + u.variant + ', + ' + money(u.price, wrap)); });
        var values = {
          bike: cfg.product + ', ' + v.title,
          build: plain(build.join('\n')),
          total: plain(money(total(result), wrap), currency),
          held: held + ' (' + holdDays + ' days, price only, in ' + currency + ')',
          page: window.location.origin + cfg.productUrl + '?variant=' + v.id
        };
        Object.keys(values).forEach(function (key) {
          var field = sendForm.querySelector('[data-bossi-field="' + key + '"]');
          if (field) field.value = values[key];
        });
        fills.forEach(function (el) {
          el.textContent = el.getAttribute('data-template')
            .replace(/\[date\]/g, held).replace(/\[currency\]/g, currency)
            .replace(/\[days\]/g, String(holdDays)).replace(/\[bike\]/g, model);
        });
        return { held: held, currency: currency, bike: model };
      }

      open.addEventListener('click', function () {
        if (!panel.hidden) {
          panel.hidden = true;
          open.setAttribute('aria-expanded', 'false');
          return;
        }
        if (!prepare()) return;
        panel.hidden = false;
        open.setAttribute('aria-expanded', 'true');
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        var first = panel.querySelector('input:not([type="hidden"])');
        if (first) try { first.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      });

      sendForm.addEventListener('submit', function (e) {
        var first = sendForm.querySelector('[data-bossi-first]');
        var last = sendForm.querySelector('[data-bossi-last]');
        var full = sendForm.querySelector('[data-bossi-fullname]');
        if (full) full.value = [first && first.value, last && last.value].filter(Boolean).join(' ').trim();
        var info = prepare();
        if (!info) {
          e.preventDefault();
          return;
        }
        try {
          sessionStorage.setItem('bossiBuildSent', JSON.stringify({ bike: info.bike, held: info.held, currency: info.currency, at: Date.now() }));
        } catch (err) { /* private browsing: the thanks page falls back to its normal message */ }
      });

      // Shopify returns here with errors if the enquiry was rejected: reopen the panel.
      if (panel.querySelector('[data-bossi-send-errors]')) {
        panel.hidden = false;
        open.setAttribute('aria-expanded', 'true');
        try { sessionStorage.removeItem('bossiBuildSent'); } catch (err) { /* ignore */ }
      }
    }
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-bossi-build]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
